import { render, staticRenderFns } from "./ProjectsDelete.vue?vue&type=template&id=a877cae2&scoped=true"
import script from "./ProjectsDelete.vue?vue&type=script&lang=js"
export * from "./ProjectsDelete.vue?vue&type=script&lang=js"
import style0 from "./ProjectsDelete.vue?vue&type=style&index=0&id=a877cae2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a877cae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a877cae2')) {
      api.createRecord('a877cae2', component.options)
    } else {
      api.reload('a877cae2', component.options)
    }
    module.hot.accept("./ProjectsDelete.vue?vue&type=template&id=a877cae2&scoped=true", function () {
      api.rerender('a877cae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Projects/ProjectsDelete.vue"
export default component.exports